import React from 'react';

const Terms = () => {
    return (
        <div className="terms-content">
            <div className="terms-article">
                <h4>제1조 (목적)</h4>
                <p>RF4 데이터 사이트(이하 '회사'라고 함)는 회사가 제공하고자 하는 서비스(이하 '회사 서비스')를 이용하는 개인(이하 '이용자' 또는 '개인')의 정보(이하 '개인정보')를 보호하기 위해, 개인정보보호법, 정보통신망 이용촉진 및 정보보호 등에 관한 법률(이하 '정보통신망법')등 관련 법령을 준수하고, 서비스 이용자의 개인정보 보호 관련한 고충을 신속하고 원활하게 처리할 수 있도록 하기 위하여 다음과 같이 개인정보처리방침(이하 '본 방침')을 수립합니다.</p>
            </div>

            <div className="terms-article">
                <h4>제2조 (개인정보 처리의 원칙)</h4>
                <p>개인정보 관련 법령 및 본 방침에 따라 회사는 이용자의 개인정보를 수집할 수 있으며 수집된 개인정보는 개인의 동의가 있는 경우에 한해 제3자에게 제공될 수 있습니다. 단, 법령의 규정 등에 의해 적법하게 강제되는 경우 회사는 수집한 이용자의 개인정보를 사전에 개인의 동의 없이 제3자에게 제공할 수도 있습니다.</p>
            </div>

            <div className="terms-article">
                <h4>제3조 (본 방침의 공개)</h4>
                <p>회사는 본 방침을 서비스 초기 화면에 게시하거나 기타의 방법으로 이용자에게 공지함으로써 본 방침을 공개합니다.</p>
            </div>

            <div className="terms-article">
                <h4>제4조 (본 방침의 변경)</h4>
                <ol>
                    <li>본 방침은 개인정보 관련 법령, 지침, 고시 또는 정부나 회사 서비스의 정책이나 내용의 변경에 따라 개정될 수 있습니다.</li>
                    <li>회사는 제1항에 따라 본 방침을 개정하는 경우 다음 각 호 하나 이상의 방법으로 공지합니다.
                        <ul>
                            <li>가. 회사가 운영하는 인터넷 홈페이지의 첫 화면의 공지사항란 또는 별도의 창을 통하여 공지하는 방법</li>
                            <li>나. 전자우편 또는 이와 비슷한 방법으로 이용자에게 공지하는 방법</li>
                        </ul>
                    </li>
                    <li>회사는 2항의 공지는 본 방침 개정의 시행일로부터 최소 7일 이전에 공지합니다. 다만, 이용자 권리의 중요한 변경이 있을 경우에는 최소 30일 전에 공지합니다.</li>
                </ol>
            </div>

            <div className="terms-article">
                <h4>제5조 (회원 가입을 위한 정보)</h4>
                <p>회사는 이용자의 회사 서비스에 대한 회원가입을 위하여 다음과 같은 정보를 수집합니다.</p>
                <ul>
                    <li>필수 수집 정보: 닉네임, 이메일 주소 및 비밀번호</li>
                </ul>
            </div>

            <div className="terms-article">
                <h4>제6조 (본인 인증을 위한 정보)</h4>
                <p>회사는 이용자의 본인인증을 위하여 다음과 같은 정보를 수집합니다.</p>
                <ul>
                    <li>필수 수집 정보: 이메일 주소 및 본인확인값(CI, DI)</li>
                </ul>
            </div>

            <div className="terms-article">
                <h4>제7조 (회사 서비스 제공을 위한 정보)</h4>
                <p>회사는 이용자에게 회사의 서비스를 제공하기 위하여 다음과 같은 정보를 수집합니다.</p>
                <ul>
                    <li>필수 수집 정보: 아이디 및 이메일 주소</li>
                </ul>
            </div>

            <div className="terms-article">
                <h4>제8조 (서비스 이용 및 부정 이용 확인을 위한 정보)</h4>
                <p>회사는 이용자의 서비스 이용에 따른 통계, 분석 및 부정이용의 확인, 분석을 위하여 다음과 같은 정보를 수집합니다. (부정이용이란 회원탈퇴 후 재가입, 서비스 운영 방해, 서비스 부정 이용 등을 의미합니다.)</p>
                <ul>
                    <li>필수 수집 정보: 서비스 이용기록, 쿠키, 접속지 정보 및 기기정보</li>
                </ul>
            </div>

            <div className="terms-article">
                <h4>제9조 (개인정보 수집 방법)</h4>
                <p>회사는 다음과 같은 방법으로 개인정보를 수집합니다.</p>
                <ol>
                    <li>이용자가 회사 서비스에 회원가입을 할 때</li>
                    <li>이용자가 회사 서비스 이용과정에서 생성되는 정보 수집</li>
                    <li>기타 회사가 제공하는 서비스 이용 과정에서 이용자가 개인정보 제공에 동의하고 제공하는 경우</li>
                </ol>
            </div>

            <div className="terms-article">
                <h4>제10조 (개인정보의 이용)</h4>
                <p>회사는 개인정보를 다음 각호의 경우에 이용합니다.</p>
                <ol>
                    <li>회원 가입 및 관리</li>
                    <li>본인 인증</li>
                    <li>회사 서비스 제공</li>
                    <li>서비스 이용 및 부정 이용 확인</li>
                </ol>
            </div>

            <div className="terms-article">
                <h4>제11조 (개인정보의 보유 및 이용기간)</h4>
                <ol>
                    <li>회사는 이용자의 개인정보에 대해 개인정보의 수집, 이용 목적 달성을 위한 기간 동안 개인정보를 보유 및 이용합니다.</li>
                    <li>전항에도 불구하고 회사는 내부 방침에 의해 서비스 부정이용기록은 부정 가입 및 이용 방비를 위하여 회원 탈퇴 시점으로부터 최대 1년간 보관합니다.</li>
                </ol>
            </div>

            <div className="terms-article">
                <h4>제12조 (법령에 따른 개인정보의 보유 및 이용기간)</h4>
                <p>회사는 관계법령에 따라 다음과 같이 개인정보를 보유 및 이용합니다.</p>
                <ol>
                    <li>통신비밀보호법에 따른 보유정보 및 보유기간
                        <ul>
                            <li>가. 웹사이트 로그 기록 자료: 3개월</li>
                        </ul>
                    </li>
                    <li>위치정보의 보호 및 이용 등에 관한 법률
                        <ul>
                            <li>가. 개인위치정보에 관한 기록: 6개월</li>
                        </ul>
                    </li>
                </ol>
            </div>

            <div className="terms-article">
                <h4>제13조 (개인정보의 파기원칙)</h4>
                <p>회사는 원칙적으로 이용자의 개인정보 처리 목적의 달성, 보유,이용기간의 경과 등 개인정보가 필요하지 않을 경우에는 해당 정보를 지체 없이 파기합니다.</p>
            </div>

            <div className="terms-article">
                <h4>제14조 (이용자의 의무)</h4>
                <ol>
                    <li>이용자는 자신의 개인정보를 최신의 상태로 유지해야 하며, 이용자의 부정확한 정보입력으로 발생하는 문제의 책임은 이용자 자신에게 있습니다.</li>
                    <li>타인의 개인정보를 도용한 회원가입의 경우 이용자 자격을 상실하거나 관련 개인정보보호 법령에 의해 처벌받을 수 있습니다.</li>
                    <li>이용자는 전자우편주소, 비밀번호 등에 대한 보안을 유지할 책임이 있으며 제3자에게 이를 양도하거나 대여할 수 없습니다.</li>
                </ol>
            </div>

            <div className="terms-article">
                <h4>제15조 (회사의 개인정보 관리)</h4>
                <p>회사는 이용자의 개인정보를 처리함에 있어 개인정보가 분실, 도난, 유출, 변조, 훼손 등이 되지 아니하도록 안정성을 확보하기 위하여 필요한 기술적, 관리적 보호대책을 강구하고 있습니다.</p>
            </div>

            <div className="terms-article">
                <h4>제16조 (비밀번호의 암호화)</h4>
                <p>이용자의 비밀번호는 일방향 암호화하여 저장 및 관리되고 있으며, 개인정보의 확인, 변경은 비밀번호를 알고 있는 본인에 의해서만 가능합니다.</p>
            </div>

            <div className="terms-article">
                <h4>제17조 (개인정보의 안전성 확보조치)</h4>
                <p>회사는 개인정보의 안전성 확보를 위해 다음과 같은 조치를 취하고 있습니다.</p>
                <ol>
                    <li>기술적 조치
                        <ul>
                            <li>개인정보 암호화: 비밀번호는 일방향 암호화하여 저장</li>
                            <li>해킹 등에 대비한 기술적 대책: 보안프로그램 설치 및 주기적 갱신</li>
                            <li>접근기록의 보관 및 위변조 방지: 접속기록을 최소 6개월 이상 보관</li>
                            <li>개인정보에 대한 접근 제한: 접근권한 관리 및 통제</li>
                        </ul>
                    </li>
                    <li>물리적 조치
                        <ul>
                            <li>전산실, 자료보관실 등의 접근통제</li>
                        </ul>
                    </li>
                </ol>
            </div>

            <div className="terms-article">
                <h4>제18조 (링크사이트)</h4>
                <ol>
                    <li>회사는 이용자에게 다른 회사의 웹사이트 또는 자료에 대한 링크를 제공할 수 있습니다. 이 경우 회사는 외부사이트 및 자료에 대한 아무런 통제권이 없으므로 그로부터 제공받는 서비스나 자료의 유용성에 대해 책임질 수 없으며 보증할 수 없습니다.</li>
                    <li>회사가 포함하고 있는 링크를 클릭하여 타 사이트의 페이지로 이동할 경우 해당 사이트의 개인정보처리방침은 회사와 무관하므로 새로 방문한 사이트의 정책을 검토해 보시기 바랍니다.</li>
                </ol>
            </div>

            <div className="terms-article">
                <h4>제19조 (해킹 등에 대비한 대책)</h4>
                <ol>
                    <li>회사는 해킹, 컴퓨터 바이러스 등 정보통신망 침입에 의해 이용자의 개인정보가 유출되거나 훼손되는 것을 막기 위해 최선을 다하고 있습니다.</li>
                    <li>회사는 최신 백신 프로그램을 이용하여 이용자들의 개인정보나 자료가 유출 또는 손상되지 않도록 방지하고 있습니다.</li>
                    <li>회사는 민감한 개인정보를 암호화 통신 등을 통하여 네트워크상에서 개인정보를 안전하게 전송할 수 있도록 하고 있습니다.</li>
                </ol>
            </div>

            <div className="terms-article">
                <h4>제20조 (개인정보 자동 수집장치의 설치, 운영 및 거부에 관한 사항)</h4>
                <ol>
                    <li>회사는 이용자에게 개별적인 맞춤 서비스를 제공하기 위해 이용 정보를 저장하고 수시로 불러오는 개인정보 자동 수집장치(이하 '쿠키')를 사용합니다. 쿠키는 웹사이트를 운영하는데 이용되는 서버가 이용자의 웹브라우저(PC 및 모바일을 포함)에게 보내는 소량의 정보이며 이용자의 저장공간에 저장되기도 합니다.</li>
                    <li>이용자는 쿠키 설치에 대한 선택권을 가지고 있습니다. 따라서 이용자는 웹브라우저에서 옵션을 설정함으로써 모든 쿠키를 허용하거나, 쿠키가 저장될 때마다 확인을 거치거나, 아니면 모든 쿠키의 저장을 거부할 수도 있습니다.</li>
                    <li>다만, 쿠키의 저장을 거부할 경우에는 로그인이 필요한 회사의 일부 서비스는 이용에 어려움이 있을 수 있습니다.</li>
                </ol>
            </div>

            <div className="terms-article terms-footer">
                <h4>부칙</h4>
                <p><strong>제1조</strong> 본 방침은 2025.10.21. 부터 시행됩니다.</p>
            </div>
        </div>
    );
};

export default Terms;
